import { useSelector } from 'react-redux'
import { useQueries } from '@tanstack/react-query'
import { getActivePatientsCount } from 'services/metrics/getActivePatientsCount'
import { getRecurringSlotsCount } from 'services/metrics/getRecurringSlotsCount'
import { ProfessionalCapacityData } from 'services/metrics/types'
import { UserData } from 'models/Auth'
import { PROFESSIONAL_HOME } from 'settings/_reactQueryConstants'

interface Options {
  enabled?: boolean;
}

interface Result {
  data: ProfessionalCapacityData | undefined;
  isLoading: boolean;
  isError: boolean;
}

const STALE_TIME = 5 * 60 * 1000

export const useProfessionalCapacity = ({ enabled = true }: Options = {}): Result => {
  const username: string = useSelector((state: UserData) => state.auth.userData.username)

  const results = useQueries({
    queries: [
      {
        queryKey: [PROFESSIONAL_HOME.ACTIVE_PATIENTS_COUNT, username],
        queryFn: () => getActivePatientsCount(username),
        staleTime: STALE_TIME,
        refetchOnMount: 'always',
        retry: 1,
        enabled: enabled && !!username,
      },
      {
        queryKey: [PROFESSIONAL_HOME.RECURRING_SLOTS_COUNT, username],
        queryFn: () => getRecurringSlotsCount(username),
        staleTime: STALE_TIME,
        refetchOnMount: 'always',
        retry: 1,
        enabled: enabled && !!username,
      },
    ],
  })

  const [active, slots] = results
  const isError = active.isError || slots.isError
  const isLoading = active.isLoading || slots.isLoading
  const data: ProfessionalCapacityData | undefined =
    active.data !== undefined && slots.data !== undefined
      ? { active_patients: active.data, recurring_slots: slots.data }
      : undefined

  return { data, isLoading, isError }
}
